import { create } from 'zustand';
import { loadGigyaScript } from '../utils';
import { CDNS_URL, CURRENT_CHANNEL, GIGYA_API_KEY } from '../constants';
export const useGigyaStore = create((set, get) => {
    return {
        isGigyaScriptLoaded: false,
        gigya: undefined,
        loadGigya: async () => {
            await loadGigyaScript({
                src: `${CDNS_URL}/js/gigya.js?apiKey=${GIGYA_API_KEY}`,
                onLoad: () => {
                    set({ isGigyaScriptLoaded: true });
                },
            });
        },
        loadGigyaSaml: async () => {
            const { origin: hostURL, search: params } = window.location;
            await loadGigyaScript({
                src: `${CDNS_URL}/js/gigya.saml.js?apiKey=${GIGYA_API_KEY}`,
                innerHTML: JSON.stringify({
                    loginURL: `${hostURL}/ciam-login${params}`,
                    logoutURL: `${hostURL}/signin/${CURRENT_CHANNEL}/logout${params}`,
                }),
            });
        },
        addOnGigyaServiceReady: ({ page, onLoginFn, hasSessionFn }) => {
            return (window.onGigyaServiceReady = async () => {
                window.gigya.accounts.getScreenSets = null;
                window.gigya.socialize.getScreenSets = null;
                if (page === 'proxy') {
                    const hasSession = await window.gigya.hasSession();
                    if (hasSession) {
                        if (hasSessionFn)
                            await hasSessionFn();
                    }
                    else
                        get().loadGigyaSaml();
                }
                window.gigya.socialize.addEventHandlers({
                    onLogin: async () => {
                        if (onLoginFn)
                            await onLoginFn();
                    },
                });
            });
        },
    };
});
//# sourceMappingURL=use-gigya-store.js.map